// import { useState, useEffect, useMemo } from "react";
// import {
//   MagnifyingGlassIcon,
//   ArrowPathIcon,
//   ChevronLeftIcon,
//   ChevronRightIcon,
//   ChevronDoubleLeftIcon,
//   ChevronDoubleRightIcon,
//   ChevronUpIcon,
//   ChevronDownIcon,
//   XMarkIcon
// } from "@heroicons/react/20/solid";

// const API_BASE = process.env.REACT_APP_API;
// const PAGE_SIZE = 500;

// const NUM_COLS = new Set(["Mill_Code", "Quantal", "Mill_Rate", "soldqty", "selfbalance", "AccountBalance"]);

// const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 }));

// const fmtDate = (d) => {
//   if (!d) return "—";
//   return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
// };

// function BalBadge({ amount, label }) {
//   if (amount == null || amount === 0) return <span className="text-slate-300">—</span>;
//   const isDr = label === "Dr";
//   return (
//     <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold ring-1 ring-inset ${isDr ? "bg-red-50 text-red-700 ring-red-600/10" : "bg-emerald-50 text-emerald-700 ring-emerald-600/10"
//       }`}>
//       {fmt(Math.abs(amount))} {label}
//     </span>
//   );
// }

// // RESTORED: Loading Skeleton
// function LoadingSkeleton() {
//   return (
//     <>
//       {[...Array(12)].map((_, idx) => (
//         <tr key={idx} className="border-b border-slate-50">
//           <td className="px-3 py-3"><div className="h-3 bg-slate-100 rounded w-6 mx-auto animate-pulse"></div></td>
//           {[...Array(9)].map((_, i) => (
//             <td key={i} className="px-3 py-3">
//               <div className="h-3 bg-slate-100 rounded animate-pulse w-full"></div>
//             </td>
//           ))}
//         </tr>
//       ))}
//     </>
//   );
// }

// const COLS = [
//   { key: "Tender_No", label: "Tender #", align: "left", width: "80px" },
//   { key: "Tender_Date", label: "Date", align: "left", width: "100px", render: v => fmtDate(v) },
//   { key: "millname", label: "Mill Name", align: "left", width: "220px", cls: "whitespace-normal break-words leading-normal text-slate-900 font-medium" },
//   { key: "paymenttoname", label: "Payment To", align: "left", width: "200px", cls: "whitespace-normal break-words leading-normal" },
//   { key: "Grade", label: "Grade", align: "left", width: "200px", cls: "whitespace-normal break-words leading-normal" },
//   { key: "Mill_Rate", label: "Mill Rate", align: "right", width: "90px", render: v => v != null ? `₹${fmt(v)}` : "—", cls: "font-mono text-slate-500" },
//   { key: "Quantal", label: "Quantal", align: "right", width: "100px", cls: "font-mono font-bold text-slate-900" },
//   { key: "soldqty", label: "Sold Quantity", align: "right", width: "90px", cls: "font-mono text-amber-600 font-medium" },
//   { key: "selfbalance", label: "Stock Balance", align: "right", width: "100px", cls: "font-mono text-emerald-600 font-bold" },
//   { key: "AccountBalance", label: "Ledger Balance", align: "right", width: "150px", render: (v, r) => <BalBadge amount={v} label={r.AccountBalanceLabel} /> },
// ];

// export default function SelfStockReport() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [search, setSearch] = useState("");
//   const [sort, setSort] = useState({ key: "Tender_No", dir: "desc" });
//   const [page, setPage] = useState(1);


//   const companyCode = sessionStorage.getItem("Company_Code");

//   useEffect(() => { fetchData(); }, []);

//   async function fetchData() {
//     setLoading(true);
//     try {
//       const res = await fetch(`${API_BASE}/tender-balance-report?Company_Code=${companyCode}`);
//       const data = await res.json();
//       setRows(data || []);
//     } catch (e) { console.error(e); }
//     finally { setLoading(false); }
//   }

//   const sortedData = useMemo(() => {
//     let filtered = rows;
//     if (search) {
//       const q = search.toLowerCase();
//       filtered = rows.filter(r => Object.values(r).some(v => String(v ?? "").toLowerCase().includes(q)));
//     }
//     return [...filtered].sort((a, b) => {
//       const av = a[sort.key] ?? 0;
//       const bv = b[sort.key] ?? 0;
//       let cmp = NUM_COLS.has(sort.key) ? Number(av) - Number(bv) : String(av).localeCompare(String(bv));
//       return sort.dir === "asc" ? cmp : -cmp;
//     });
//   }, [rows, search, sort]);

//   const paged = sortedData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
//   const totalPages = Math.ceil(sortedData.length / PAGE_SIZE);
//   const totalQuantal = useMemo(() => rows.reduce((sum, r) => sum + (Number(r.Quantal) || 0), 0), [rows]);

//   const handleSort = (key) => {
//     setSort(prev => ({ key, dir: prev.key === key && prev.dir === "asc" ? "desc" : "asc" }));
//   };

//   return (
//     <div className="flex flex-col h-full bg-white animate-in fade-in duration-300">
//       {/* Top Bar */}
//       <div className="flex items-center justify-between px-6 py-3 border-b border-slate-100 gap-4">
//         <div className="relative w-full max-w-sm">
//           <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
//           <input
//             value={search}
//             onChange={e => { setSearch(e.target.value); setPage(1); }}
//             placeholder="Search stocks..."
//             className="w-full pl-10 pr-4 py-2 text-xs border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all"
//           />
//         </div>

//         <div className="flex items-center gap-6">
//           <div className="flex flex-col items-end">
//             <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Total Quantal</span>
//             <span className="text-base font-mono font-bold text-blue-600 leading-none">{fmt(totalQuantal)}</span>
//           </div>

//         </div>
//       </div>

//       {/* Main Table Area */}
//       <div className="overflow-x-auto overflow-y-auto no-scrollbar mb-[30px]">
//         <table className="w-full text-[12.5px] border-separate border-spacing-0 table-auto" style={{ minWidth: 1100 }}>
//           <thead className="sticky top-0 z-10 bg-slate-50">
//             <tr>
//               <th className="px-4 py-2.5 text-center text-[10px] font-bold text-slate-400 uppercase tracking-wider border-b border-slate-200 w-12">#</th>
//               {COLS.map(col => (
//                 <th
//                   key={col.key}
//                   style={{ width: col.width }}
//                   onClick={() => handleSort(col.key)}
//                   className={`px-4 py-2.5 text-[10px] font-bold text-slate-500 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100 transition-colors ${col.align === "right" ? "text-right" : "text-left"}`}
//                 >
//                   <div className={`flex items-center gap-1.5 ${col.align === "right" ? "justify-end" : ""}`}>
//                     {col.label}
//                     <span className="flex flex-col -space-y-1">
//                       <ChevronUpIcon className={`w-3 h-3 ${sort.key === col.key && sort.dir === "asc" ? "text-blue-600" : "text-slate-300"}`} />
//                       <ChevronDownIcon className={`w-3 h-3 ${sort.key === col.key && sort.dir === "desc" ? "text-blue-600" : "text-slate-300"}`} />
//                     </span>
//                   </div>
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-slate-100">
//             {loading ? (
//               <LoadingSkeleton />
//             ) : paged.length === 0 ? (
//               <tr><td colSpan={12} className="py-20 text-center text-slate-400 italic">No records found...</td></tr>
//             ) : (
//               paged.map((row, i) => (
//                 <tr key={i} className="hover:bg-blue-50/40 transition-colors group">
//                   <td className="px-4 py-2.5 text-center text-slate-300 font-mono text-[11px] border-r border-slate-50">
//                     {(page - 1) * PAGE_SIZE + i + 1}
//                   </td>
//                   {COLS.map(col => (
//                     <td
//                       key={col.key}
//                       className={`px-4 py-2.5 ${col.align === "right" ? "text-right" : "text-left"} ${col.cls || "text-slate-600"}`}
//                     >
//                       {col.render ? col.render(row[col.key], row) : (row[col.key] ?? "—")}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Blue & White Pagination Footer */}
//       <div className="mt-auto border-t border-blue-100 bg-white px-6 py-3 flex items-center justify-end gap-6 mb-[30px]">
//         <div className="flex items-center gap-2 bg-blue-50/50 p-1 rounded-xl border border-blue-100 shadow-sm">
//           <button onClick={() => setPage(1)} disabled={page === 1 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
//             <ChevronDoubleLeftIcon className="w-4.5 h-4.5" />
//           </button>
//           <button onClick={() => setPage(p => p - 1)} disabled={page === 1 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
//             <ChevronLeftIcon className="w-4.5 h-4.5" />
//           </button>
//           <span className="text-[10px] font-bold px-4 text-blue-900/60 uppercase tracking-widest border-x border-blue-100">
//             Page <span className="text-blue-600">{page}</span> / {totalPages || 1}
//           </span>
//           <button onClick={() => setPage(p => p + 1)} disabled={page === totalPages || totalPages === 0 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
//             <ChevronRightIcon className="w-4.5 h-4.5" />
//           </button>
//           <button onClick={() => setPage(totalPages)} disabled={page === totalPages || totalPages === 0 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
//             <ChevronDoubleRightIcon className="w-4.5 h-4.5" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }





















import { useState, useEffect, useMemo, useRef } from "react";
import {
  MagnifyingGlassIcon,
  ArrowPathIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  ArrowDownTrayIcon,
  PrinterIcon,
} from "@heroicons/react/20/solid";
import * as XLSX from "xlsx";
import DailyPurchaseReport from "./DailyPurchaseReport";
import TrailBalanceReport from "./TrailBalanceReport";


const API_BASE = process.env.REACT_APP_API;
const PAGE_SIZE = 500;

const NUM_COLS = new Set(["Mill_Code", "Quantal", "Mill_Rate", "soldqty", "selfbalance", "AccountBalance"]);

const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 }));

const fmtDate = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

function BalBadge({ amount, label }) {
  if (amount == null || amount === 0) return <span className="text-slate-300">—</span>;
  const isDr = label === "Dr";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold ring-1 ring-inset ${isDr ? "bg-red-50 text-red-700 ring-red-600/10" : "bg-emerald-50 text-emerald-700 ring-emerald-600/10"}`}>
      {fmt(Math.abs(amount))} {label}
    </span>
  );
}

function LoadingSkeleton() {
  return (
    <>
      {[...Array(12)].map((_, idx) => (
        <tr key={idx} className="border-b border-slate-50">
          <td className="px-3 py-3"><div className="h-3 bg-slate-100 rounded w-6 mx-auto animate-pulse"></div></td>
          {[...Array(9)].map((_, i) => (
            <td key={i} className="px-3 py-3">
              <div className="h-3 bg-slate-100 rounded animate-pulse w-full"></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

const COLS = [
  { key: "Tender_No", label: "Tender #", align: "left", width: "80px" },
  { key: "Tender_Date", label: "Date", align: "left", width: "100px", render: v => fmtDate(v) },
  { key: "millname", label: "Mill Name", align: "left", width: "220px", cls: "whitespace-normal break-words leading-normal text-slate-900 font-medium" },
  { key: "paymenttoname", label: "Payment To", align: "left", width: "200px", cls: "whitespace-normal break-words leading-normal" },
  { key: "Grade", label: "Grade", align: "left", width: "200px", cls: "whitespace-normal break-words leading-normal" },
  { key: "Mill_Rate", label: "Mill Rate", align: "right", width: "90px", render: v => v != null ? `₹${fmt(v)}` : "—", cls: "font-mono font-bold text-slate-900" },
  { key: "Quantal", label: "Quantal", align: "right", width: "100px", cls: "font-mono font-bold text-slate-900" },
  { key: "soldqty", label: "Sold Quantity", align: "right", width: "90px", cls: "font-mono text-amber-600 font-medium" },
  { key: "selfbalance", label: "Stock Balance", align: "right", width: "100px", cls: "font-mono text-emerald-600 font-bold" },
  { key: "AccountBalance", label: "Ledger Balance", align: "right", width: "150px", render: (v, r) => <BalBadge amount={v} label={r.AccountBalanceLabel} /> },
];

// Raw value extractor for export (no JSX rendering)
function getRawValue(col, row) {
  const v = row[col.key];
  if (col.key === "Tender_Date") return fmtDate(v);
  if (col.key === "Mill_Rate") return v != null ? Number(v) : null;
  if (col.key === "AccountBalance") {
    const abs = v != null ? Math.abs(Number(v)) : null;
    const label = row.AccountBalanceLabel || "";
    return abs != null ? `${fmt(abs)} ${label}` : "—";
  }
  if (NUM_COLS.has(col.key)) return v != null ? Number(v) : null;
  return v ?? "—";
}

export default function SelfStockReport() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState({ key: "Tender_No", dir: "desc" });
  const [page, setPage] = useState(1);
  const printRef = useRef(null);

  const companyCode = sessionStorage.getItem("Company_Code");

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/tender-balance-report?Company_Code=${companyCode}`);
      const data = await res.json();
      setRows(data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }

  const sortedData = useMemo(() => {
    let filtered = rows;
    if (search) {
      const q = search.toLowerCase();
      filtered = rows.filter(r => Object.values(r).some(v => String(v ?? "").toLowerCase().includes(q)));
    }
    return [...filtered].sort((a, b) => {
      const av = a[sort.key] ?? 0;
      const bv = b[sort.key] ?? 0;
      let cmp = NUM_COLS.has(sort.key) ? Number(av) - Number(bv) : String(av).localeCompare(String(bv));
      return sort.dir === "asc" ? cmp : -cmp;
    });
  }, [rows, search, sort]);

  const paged = sortedData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const totalPages = Math.ceil(sortedData.length / PAGE_SIZE);
  const totalQuantal = useMemo(() => rows.reduce((sum, r) => sum + (Number(r.Quantal) || 0), 0), [rows]);

  const handleSort = (key) => {
    setSort(prev => ({ key, dir: prev.key === key && prev.dir === "asc" ? "desc" : "asc" }));
  };

  // ─── XLSX Export ────────────────────────────────────────────────────────────
  function handleExportXLSX() {
    const headers = ["#", ...COLS.map(c => c.label)];
    const dataRows = sortedData.map((row, i) => [
      i + 1,
      ...COLS.map(col => getRawValue(col, row)),
    ]);

    // Total row
    const totalRow = [
      "TOTAL",
      ...COLS.map(col => {
        if (col.key === "Quantal") return Number(totalQuantal.toFixed(2));
        if (col.key === "soldqty") return sortedData.reduce((s, r) => s + (Number(r.soldqty) || 0), 0);
        if (col.key === "selfbalance") return sortedData.reduce((s, r) => s + (Number(r.selfbalance) || 0), 0);
        return "";
      }),
    ];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([headers, ...dataRows, totalRow]);

    // Column widths
    ws["!cols"] = [
      { wch: 5 },   // #
      { wch: 10 },  // Tender #
      { wch: 14 },  // Date
      { wch: 30 },  // Mill Name
      { wch: 28 },  // Payment To
      { wch: 28 },  // Grade
      { wch: 12 },  // Mill Rate
      { wch: 12 },  // Quantal
      { wch: 14 },  // Sold Qty
      { wch: 14 },  // Stock Bal
      { wch: 18 },  // Ledger Bal
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Self Stock Report");
    XLSX.writeFile(wb, `SelfStockReport_${new Date().toISOString().slice(0, 10)}.xlsx`);
  }

  // ─── Print ──────────────────────────────────────────────────────────────────
  function handlePrint() {
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Self Stock Report</title>
        <style>
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { font-family: Arial, sans-serif; font-size: 10px; color: #1e293b; padding: 16px; }
          h2 { font-size: 14px; font-weight: 700; color: #1e3a5f; margin-bottom: 2px; }
          .meta { font-size: 9px; color: #64748b; margin-bottom: 10px; }
          table { width: 100%; border-collapse: collapse; font-size: 9.5px; }
          thead th {
            background: #1e3a5f;
            color: #fff;
            padding: 5px 8px;
            text-align: left;
            font-weight: 600;
            white-space: nowrap;
          }
          thead th.right { text-align: right; }
          tbody tr:nth-child(even) { background: #f8fafc; }
          tbody tr:hover { background: #eff6ff; }
          td { padding: 4px 8px; border-bottom: 1px solid #e2e8f0; vertical-align: top; }
          td.right { text-align: right; font-family: monospace; }
          td.bold { font-weight: 700; }
          td.amber { color: #d97706; }
          td.green { color: #059669; font-weight: 700; }
          td.dr { color: #b91c1c; font-weight: 700; }
          td.cr { color: #059669; font-weight: 700; }
          tfoot td {
            background: #1e3a5f;
            color: #fff;
            font-weight: 700;
            padding: 5px 8px;
            border-top: 2px solid #0f2a4a;
          }
          tfoot td.right { text-align: right; font-family: monospace; }
          .summary { margin-top: 10px; font-size: 9px; color: #64748b; }
          @media print {
            body { padding: 8px; }
            @page { margin: 10mm; size: A3 landscape; }
          }
        </style>
      </head>
      <body>
        <h2>Self Stock Report</h2>
        <div class="meta">
          Generated on: ${new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
          &nbsp;|&nbsp; Total Records: ${sortedData.length}
          &nbsp;|&nbsp; Total Quantal: ${fmt(totalQuantal)}
          ${search ? `&nbsp;|&nbsp; Filter: "${search}"` : ""}
        </div>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Tender #</th>
              <th>Date</th>
              <th>Mill Name</th>
              <th>Payment To</th>
              <th>Grade</th>
              <th class="right">Mill Rate (₹)</th>
              <th class="right">Quantal</th>
              <th class="right">Sold Qty</th>
              <th class="right">Stock Bal</th>
              <th class="right">Ledger Bal</th>
            </tr>
          </thead>
          <tbody>
            ${sortedData.map((row, i) => {
              const bal = row.AccountBalance;
              const label = row.AccountBalanceLabel;
              const balClass = bal == null || bal === 0 ? "" : label === "Dr" ? "dr" : "cr";
              const balText = bal == null || bal === 0 ? "—" : `${fmt(Math.abs(bal))} ${label}`;
              return `
                <tr>
                  <td>${i + 1}</td>
                  <td>${row.Tender_No ?? "—"}</td>
                  <td>${fmtDate(row.Tender_Date)}</td>
                  <td class="bold">${row.millname ?? "—"}</td>
                  <td>${row.paymenttoname ?? "—"}</td>
                  <td>${row.Grade ?? "—"}</td>
                  <td class="right">${row.Mill_Rate != null ? `₹${fmt(row.Mill_Rate)}` : "—"}</td>
                  <td class="right bold">${fmt(row.Quantal)}</td>
                  <td class="right amber">${fmt(row.soldqty)}</td>
                  <td class="right green">${fmt(row.selfbalance)}</td>
                  <td class="right ${balClass}">${balText}</td>
                </tr>`;
            }).join("")}
          </tbody>
          <tfoot>
            <tr>
              <td colspan="7">TOTAL (${sortedData.length} records)</td>
              <td class="right">${fmt(totalQuantal)}</td>
              <td class="right">${fmt(sortedData.reduce((s, r) => s + (Number(r.soldqty) || 0), 0))}</td>
              <td class="right">${fmt(sortedData.reduce((s, r) => s + (Number(r.selfbalance) || 0), 0))}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
        <div class="summary">* Ledger Balance: Dr = Debit (receivable), Cr = Credit (payable)</div>
      </body>
      </html>
    `;

    const win = window.open("", "_blank", "width=1200,height=800");
    win.document.write(printContent);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); }, 300);
  }

  return (
    <div className="flex flex-col h-full bg-white animate-in fade-in duration-300">
      {/* Top Bar */}
      <div className="flex items-center justify-between px-6 py-3 border-b border-slate-100 gap-4">
        <div className="relative w-full max-w-sm">
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }}
            placeholder="Search stocks..."
            className="w-full pl-10 pr-4 py-2 text-xs border border-slate-200 rounded-xl bg-slate-50 focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all"
          />
        </div>

        <div className="flex items-center gap-4">
          {/* Total Quantal */}
          <div className="flex flex-col items-end">
            <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Total Quantal</span>
            <span className="text-base font-mono font-bold text-blue-600 leading-none">{fmt(totalQuantal)}</span>
          </div>

          {/* Export XLSX */}
          <button
            onClick={handleExportXLSX}
            disabled={loading || rows.length === 0}
            className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-600 hover:text-white hover:border-emerald-600 disabled:opacity-40 transition-all shadow-sm"
            title="Export to Excel"
          >
            <ArrowDownTrayIcon className="w-4 h-4" />
            Export XLSX
          </button>

          {/* Print */}
          <button
            onClick={handlePrint}
            disabled={loading || rows.length === 0}
            className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-[11px] font-semibold bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-600 hover:text-white hover:border-blue-600 disabled:opacity-40 transition-all shadow-sm"
            title="Print Report"
          >
            <PrinterIcon className="w-4 h-4" />
            Print
          </button>
        </div>
      </div>

      {/* Main Table Area */}
      <div className="overflow-x-auto overflow-y-auto no-scrollbar mb-[30px]">
        <table className="w-full text-[12.5px] border-separate border-spacing-0 table-auto" style={{ minWidth: 1100 }}>
          <thead className="sticky top-0 z-10 bg-slate-50">
            <tr>
              <th className="px-4 py-2.5 text-center text-[10px] font-bold text-slate-400 uppercase tracking-wider border-b border-slate-200 w-12">#</th>
              {COLS.map(col => (
                <th
                  key={col.key}
                  style={{ width: col.width }}
                  onClick={() => handleSort(col.key)}
                  className={`px-4 py-2.5 text-[10px] font-bold text-slate-500 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100 transition-colors ${col.align === "right" ? "text-right" : "text-left"}`}
                >
                  <div className={`flex items-center gap-1.5 ${col.align === "right" ? "justify-end" : ""}`}>
                    {col.label}
                    <span className="flex flex-col -space-y-1">
                      <ChevronUpIcon className={`w-3 h-3 ${sort.key === col.key && sort.dir === "asc" ? "text-blue-600" : "text-slate-300"}`} />
                      <ChevronDownIcon className={`w-3 h-3 ${sort.key === col.key && sort.dir === "desc" ? "text-blue-600" : "text-slate-300"}`} />
                    </span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loading ? (
              <LoadingSkeleton />
            ) : paged.length === 0 ? (
              <tr><td colSpan={12} className="py-20 text-center text-slate-400 italic">No records found...</td></tr>
            ) : (
              paged.map((row, i) => (
                <tr key={i} className="hover:bg-blue-50/40 transition-colors group">
                  <td className="px-4 py-2.5 text-center text-slate-300 font-mono text-[11px] border-r border-slate-50">
                    {(page - 1) * PAGE_SIZE + i + 1}
                  </td>
                  {COLS.map(col => (
                    <td
                      key={col.key}
                      className={`px-4 py-2.5 ${col.align === "right" ? "text-right" : "text-left"} ${col.cls || "text-slate-600"}`}
                    >
                      {col.render ? col.render(row[col.key], row) : (row[col.key] ?? "—")}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer */}
      <div className="mt-auto border-t border-blue-100 bg-white px-6 py-3 flex items-center justify-end gap-6 mb-[30px]">
        <div className="flex items-center gap-2 bg-blue-50/50 p-1 rounded-xl border border-blue-100 shadow-sm">
          <button onClick={() => setPage(1)} disabled={page === 1 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
            <ChevronDoubleLeftIcon className="w-4.5 h-4.5" />
          </button>
          <button onClick={() => setPage(p => p - 1)} disabled={page === 1 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
            <ChevronLeftIcon className="w-4.5 h-4.5" />
          </button>
          <span className="text-[10px] font-bold px-4 text-blue-900/60 uppercase tracking-widest border-x border-blue-100">
            Page <span className="text-blue-600">{page}</span> / {totalPages || 1}
          </span>
          <button onClick={() => setPage(p => p + 1)} disabled={page === totalPages || totalPages === 0 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
            <ChevronRightIcon className="w-4.5 h-4.5" />
          </button>
          <button onClick={() => setPage(totalPages)} disabled={page === totalPages || totalPages === 0 || loading} className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-600 hover:text-white disabled:opacity-30 transition-all">
            <ChevronDoubleRightIcon className="w-4.5 h-4.5" />
          </button>
        </div>
      </div>
      {/* <DailyPurchaseReport/>
      <TrailBalanceReport/> */}
    </div>
  );
}